import { defineMessages } from '@atlassian/jira-intl';

export const messages = defineMessages({
	closeBannerAriaLabel: {
		id: 'business-trial-banner.close-banner-aria-label',
		defaultMessage: 'Close premium upgrade banner',
		description: 'Button label to close the premium upgrade banner',
	},
	premiumSuccessDescription: {
		id: 'business-trial-banner.premium-success-description',
		defaultMessage:
			'At anytime before {formattedTrialEndDate}, add a payment method to stay on the Premium plan.',
		description: 'Description of flag for successful upgrade to Jira Premium',
	},
	premiumSuccessTitle: {
		id: 'business-trial-banner.premium-success-title',
		defaultMessage: 'You’ve got 14 days of Premium',
		description: 'Title of flag for successful upgrade to Jira Premium',
	},
	premiumTrialContentComplexspork: {
		id: 'business-trial-banner.premium-trial-content-complexspork',
		defaultMessage:
			'Unlock advanced features for cross-functional collaboration with Jira Premium.',
		description: 'Content for the Jira Premium upgrade banner',
	},
	premiumTrialCta: {
		id: 'business-trial-banner.premium-trial-cta',
		defaultMessage: 'Try Premium',
		description: 'Button label to open upgrade flow to Jira premium',
	},
});
